import { Component } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'demo-layout',
    templateUrl: './demo-layout.html',
    styleUrls: ['./demo-common.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoLayoutComponent {
    dropdownExpanded = false;
    scrollDirection: 'none' | 'x' | 'y' | 'both' = 'y';
    visibilityStatus = 'unknown';

    scrollItems: string[] = [];

    constructor() {
        for (let i = 1; i <= 30; i++) {
            this.scrollItems.push('Scrollable item ' + i);
        }
    }

    toggleDropdown() {
        this.dropdownExpanded = !this.dropdownExpanded;
    }

    onDropdownClosed() {
        this.dropdownExpanded = false;
    }

    cycleScrollDirection() {
        const dirs: Array<'none' | 'x' | 'y' | 'both'> = ['none', 'x', 'y', 'both'];
        const idx = dirs.indexOf(this.scrollDirection);
        this.scrollDirection = dirs[(idx + 1) % dirs.length];
    }

    onVisibilityChange(isVisible: boolean) {
        this.visibilityStatus = isVisible ? 'visible' : 'hidden';
    }
}
